module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("O")]), _vm._v("ctober 14, 2009")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Dear Diary,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("After two long weeks of stitching, unstitching, mending and ironing, the day is finally at my doorstep. I’m so excited as rehearsals are set to begin tomorrow and the wardrobe department is buzzing with activity in order to have everything ready. I look forward to hearing the first notes of this opera I’ve been burning my fingers for. My love for this Opera House has grown and I relish every day here. Mrs. Henley, who insists I call her Roberta, is a dear and I adore working for her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("While I do miss my mom, I’m thankful to have Roberta as a surrogate.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Is that music I hear?” I set down the petticoat I’d been sewing lace to and listened to the faint rumblings of a distant piano.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Knowing my eagerness to hear more of the music from The Masquerade at the Met, Roberta nodded, giving me her silent permission to sneak a peek downstairs.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With every step I took, the music came in clearer and my excitement grew. I’d heard so much about this mysterious opera that had been found in the crypts beneath the old Opera House in Paris. Word had it an obscure maestro from the Paris Opera House, rumored to be "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the")]), _vm._v(" phantom of the opera, had written the haunting and unforgettable music.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The music stopped momentarily, started again and stopped once more. By the time I arrived, the lead singer was taking her place and setting to sing her first note.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A few haunting notes from the piano filled the auditorium and a shiver of anticipation ran over every inch of my skin. I’d participated in several school plays in New Orleans and I had heard a multitude of musicians as I’d strolled down Bourbon Street, but nothing could compare to the excitement that now filled me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The singer, pretty in her long blond tresses, opened her mouth and my anticipation grew. Her eyes, green and piercing, gazed all around her and quickly narrowed in annoyance. The lips that had been poised to let out the first notes quickly clamped down shut and set into a straight and grim line.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I glanced around to see what had caused her to become suddenly irate, and by the time my gaze returned to her, her hate filled eyes were pinned on me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Who are you and what are you doing here?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Her words were so biting and her tone so shrill, I could barely imagine her singing could be anything remotely resembling melodious. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I... I... just...” I had no justifiable reason for being there. I’d not thought to drag along a garment to be fitted as an excuse.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Get out!” she shouted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Stunned, I just stood there for a moment. This was far from the southern hospitality I’d grown up with, and while I’d heard New Yorkers could be a bit harder and colder, I had in no way expected such a reaction from this diva.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Get out! Get out! Get out!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With my face heating up like iced-tea left out in the noonday sun, I turned away from the stage and marched up the aisle to the door at the back of the auditorium. I could feel the tears working their way to my eyes and hated the thought of crying over some snit who thought she was a star.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Don’t let her get to you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The pleasant voice followed me out to the main hall of the Opera House. I turned to the toned and muscular build of a girl who was several inches shorter than me, but who carried herself with the confidence I presently lacked. Her short red hair was sassy, almost quirky, as was her style of dress, and she exuded an air of artistic flamboyance that I immediately liked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m Judy, one of the dancers. You’re new here, right?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Working with Mrs. Henley.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Roberta, great woman. Easier to work with than Prima Donna out there.” She thinks that just because she’s playing Adelle, leading princess of this Masquerade, she can push everyone around.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So she’s like that with everyone?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hmm, not usually quite so quick to be so nasty.  No, I’d say she clearly doesn’t like you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But I don’t even know her. I don’t think I’ve even worked on any of her garments so it can’t be my workmanship she’s unhappy with. And I didn’t make a sound while I was in there. Is my simple presence enough to send her on a tirade?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stared dumbly at her. It seemed impossible and was completely insane.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Marie Abere is not only the star of this extravaganza, but she is also the most beautiful woman in all of the New York Metropolitan Opera House, if not all of Manhattan, or so she likes to think. You’re obviously more beautiful than she is, and she’s not taking it too well.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s absurd.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s Marie.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Her matter of fact attitude was amusing and refreshing. It was funny how in one short minute I could meet someone who I could detest so instantly and also meet someone I could find so irresistibly likable.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How can one girl be so obnoxious?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Some blame it on the Legend of the Masquerade.  Personally, I think she’s just nuts.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The Legend?” Now I was intrigued.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Roberta hasn’t told you about the Legend yet?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("An excited thrill ran through me and I silently berated Roberta for not letting me in on this juicy bit of information. A legend in New York. It was almost as exciting as VooDoo in New Orleans.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll admit she’d warned me about Marie, though I still wouldn’t have expected such a reaction, but she said nothing about a legend.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, when The Masquerade first ran in Paris, it was hugely successful. It was the talk of the opera world and was touted as being a work of musical genius. Kristine, the lead in the opera, was said to be the next big thing. Then a story leaked that she’d been involved with the Phantom composer and her lover was not too happy about it. Turned out the Phantom had been accused of murder and he just disappeared one night. No one ever saw him again. And poor Kristin died heartbroken because her lover refused to marry her following the scandal.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was all so unbelievably romantic.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Some are already taking bets on what scandal Marie will create. Personally, I think she’s having an affair with more than one man involved with this production. How else could she have gotten this job?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don’t know, but I got this job thanks to my mom and I better hurry back or I’ll lose it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I returned to the wardrobe department while Judy set off for rehearsal. A few notes continued to make their way up, but not enough for me to judge the quality of the diva’s voice. By the time I resumed my seat, I put Marie out of my mind and concentrated on the length of lace that still had to be stitched to that petticoat.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("An hour later, Roberta got to her feet. “I’m going to bring our lovely leading lady the costume for her opening number,” she declared as she thrust the heavy garment over her shoulder. “Come along, Annette, in case she needs any adjustments.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I turned to her in disbelief. Did she really want me to go back down there and face that tigress? I wanted to protest, but she was already halfway out the door. Reluctantly, I got up and dragged my feet to follow behind her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And bring your pin cushion.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I’d come to think the pincushion attached to my wrist was a permanent fixture. Were it not for the fact that it didn’t easily slip into the sleeve of my leather jacket, I probably would have absentmindedly left with it every night. It was bad enough I sometimes took the subway with lint, lengths of thread and tuffs of fur clinging to my pants, without having this bright red pin cushion advertising to everyone what I did for a living.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Not that I was ashamed of my line of profession. I was actually quite proud. I just didn’t want to walk about town with remnants of my work on my sleeve, as it were.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Chatting about trousers that needed mending, overcoats to embellish and bejeweled ball gowns that had yet to be assembled at all, Roberta led me down to the dressing rooms. The corridors were brightly lit and Marie’s door was clearly identified. Though curious to see the inside of the dressing room, I remained in the hall as Roberta brought the dress in to be fitted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Marie was curt, even with Roberta.  “Really, Roberta. Did you know that we have a show starting soon and that I still have hours of rehearsal and that waiting for you to finally make your way here isn’t really in my plans.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Is that so, dear?” Roberta hardly seemed fazed by Marie’s outburst. “Here you go.  I’ll help you get this on.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I heard the rustling of luxurious fabrics, and few groans and grunts then the sound no seamstress ever wants to hear.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“My God! What did you do?” Marie shouted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You pulled up too quickly.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No. You made the damn thing too tight,” Marie screeched.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I peeked in to see a large tear at the back of the dress and Marie’s bare back. Roberta glanced at me and waved me in.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Damn it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Not wanting Marie to hear me enter, I didn’t risk pushing the door open and simply slid in through the tight opening where the door was barely ajar. I silently stood there, dreading Marie’s wrath.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don’t understand,” Roberta said. “I took your measurements just days ago and I’ve adhered to them in the most stringent way. I never miss a measurement. If anything, I usually leave a little leeway.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Marie turned and shot Roberta such a venomous glare. I shuddered.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Are you insinuating I’ve gained weight in the past few days?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, absolutely not.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Her venom was then aimed at me. “You.  The hillbilly from the south. I bet you worked on this piece of crap and got the measurements all wrong.” She stepped out of the garment and kicked it away. “Go back and get it right this time.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Not bothering to cover her nude body, she turned to the mirror in the corner and almost smiled at her reflection. I’d never seen someone so enamored with their own beauty. She whipped her head around towards us and she spat, “Are you still there? What are you waiting for? Fix that stupid thing.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Roberta and I hurried out and while I felt my nerves frazzle like never before, I glimpsed Roberta chuckling. She shot me a funny face, made an obscene gesture towards Marie’s door and led me back to the stairs.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("By the time we reached the landing, we were howling with laughter.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The only way to deal with that girl is to laugh it off,” Roberta said. “Don’t let her get to you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ve never seen someone be so nasty.” I smiled, happy to be sharing this moment with her. Had I been alone with Marie, no doubt I would have left the dressing room in tears.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("After three hours spent mending the tight garment, Roberta sent me to see Marie again. Finding her dressing room empty, I laid the heavy gown on the back of a chair and went in search of her in the auditorium.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("On opening the door, I heard her lamentations aimed at the orchestra pit.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How many times do I have to tell you, Renfrew? There is no modulation after the first verse. And who gave you permission to change the key. This was supposed to be in B minor. What key are you giving me?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Renfrew, the piano player who already seemed out of patience, inspected the music sheets. “The B minor has been scratched out and replaced with C minor.” He pointed to the second sheet. “And right here, there "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is")]), _vm._v(" a modulation.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Marie bundled her fists together and pounded them into her thighs. Her face reddened to an almost purple hue. A tense hush fell over the stage and the entire auditorium. The few cast members in attendance shifted their gaze between Marie and Renfrew with nervous anticipation.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A stage hand, unaware of the goings-on, crossed the stage and inspected the scattered contents of the set.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What the hell are you doing?” Marie turned away from the Renfrew and pointed her anger at the hapless worker.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Renfrew, stood, rolled his eyes to the ceiling high above and ran his hand over the sweaty top of his bald head. The day of rehearsal had been long and it was evident in his face.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The stage hand, unperturbed by Miss Diva’s ire, was calm as could be as he continued with his inspection.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hey! You!” Marie called out. “Broadway reject! I’m rehearsing here.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He turned a cool eye her way, smirked then turned to Tom, the stage director, who appeared from side stage. “Tom, it’s even worse than I thought. In addition to the gold sword, we’re missing the candelabrum and the emerald encrusted dagger.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Have you checked the prop room?” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Three times. They were all there this morning and now...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Could you guys wrap this up some other time? I’m in the middle of my most complex...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Is someone in the rehearsal hall?” Tom coldly asked. “There’s nothing keeping you from going there instead of taking up the whole stage here. We’ve got work to do as well.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Marie turned on her heel, pointed to Renfrew and shouted, “B minor, no modulation!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The music began, in B minor, and Marie began singing. “"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("My heart shall ache / my love will not be enough / I’ll never wake / and feel able to lust.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Despite the words of love, the melody came out hard and unemotional. Her voice seemed to have a vague capacity to be sweet and carry far up to the furthest balcony, but the coldness of her heart didn’t allow for the sweetness to flow through the melody.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Marie’s angry voice was soon joined by a faint murmur that seemed to come from high above. She glanced up, her eyes blazing with annoyance. “"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I gave all I had / my heart was yours to hold / now I’m alone outside / I’ve never been so cold.” ")]), _vm._v("The melody was almost lost behind the grating tone of her voice.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A slight rumbling shook under my feet and I glanced at the stage director, certain he was testing the stage sets. Nothing was moving. The rumbling increased, groaned ominously and rose high into the air, setting every hair on my back on alert. My fingers reached for my cross of rubies and worked feverishly over the stones.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Renfrew stopped and the stage hand froze.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My breathing stopped.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Marie’s solitary note rang from her throat, coarse and pained, as though she’d not heard a thing. Only when she realized the music had ceased did she stop.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The rumbling became an audible growl that seemed to seep over the stage from every crack in the wall. I had to cover my ears as the groans became a roar that seemed to consume the air in the auditorium")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My legs went numb, though I desperately wanted to run away.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What is that?” Marie’s shout echoed throughout the cavernous auditorium and returned to her on echo after echo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As suddenly as it had begun, the sound stopped and all was silent.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I think the guys are testing the lift.” Tom’s eyes were far more concerned than his words let on.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Urgh,” Marie grunted. “Start again,” she ordered Renfrew.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Again the melody filled the air accompanied by Marie’s hardened voice.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Again, the rumbling shook my feet and slowly filled the air.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What the hell is that?” Marie screamed into the air.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll go check where it could be coming from.” Tom left the stage for a few moments, and throughout his inspection, the auditorium remained silent.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("After a thorough check, nothing was found.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The piano rang in the air and Marie, more tentatively this time, began singing again. No slow build up of a rumble warned of the growl to come this time. A tremendous roar simply filled the auditorium, drowning out Marie and Renfrew and chilling the air.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-o"
  }, [_vm._v("O")]), _vm._v("CTOBER 15")]), _c('sup', [_vm._v("th")]), _vm._v(", 2009")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Dear Diary,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Most of the night was spent dreaming of this Phantom. I would never admit it to anyone, but I believe I’m enamored with this legendary figure. The strange goings-on at the Opera House are eerie, but I’m always eager to go back. Just being near that stage is enough to make me dream of a day when I’ll be talented enough to set foot on that shiny floor with the spotlight on me.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene with-quote character-h"
  }, [_vm._v("“H")]), _vm._v("EY, JUDY,” I SAID")]), _vm._v(" as I grabbed a very needed third cup of coffee. “What’s going on? Everyone seems so on edge.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("From the moment I’d entered the Opera House, I felt the tension. Directors and coordinators spoke in hushed tones in corridors. Singers gazed nervously about as though expecting the end of the world.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Did you hear about what happened at rehearsal yesterday?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yeah, kind of creepy, isn’t it? I still have goose bumps just thinking about it.” Was that what had everyone so skittish?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Marie left the show.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Are you serious?” Though I knew Marie had been angered by the strange sounds, her departure seemed so out of character for such a strong girl.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Whatever that noise was, it spooked her out so much, they cancelled the rehearsal and she just walked out.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, maybe she’ll show up,” I optimistically chirped.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("After dropping three spoons of sugar into her black coffee, Judy glanced up at me. “Even if she did, they’ve postponed the show.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“They didn’t.” A postponement could mean death to the show.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“They did.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A lean young man with sunny curls and an infectious grin came up and playfully punched Judy in the arm. “Hey, Prancer. You sticking around here long?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I glanced at him and he nodded in greeting.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Just long enough to swallow a few of these down.” She turned to me. “Annette, do you know Chace?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Nope.” I stuck my hand out and he took it in a very genteel fashion.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Nice to meet you, Annette. You a dancer like Prancer here?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I guffawed and brought my hand to my mouth. Me, a dancer. Hardly. “No, I’m in wardrobe.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He gave me a playful up and down glance.  “And a nice wardrobe it is.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Chace,” Judy chastised as she slapped him soundly across the chest.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It was a compliment,” he whined while rubbing his bicep. “Nice fitting jeans, cool shirt that complements her thick mass of dark hair. And a cool cross around her neck.  I give her a nine.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Don’t mind him, Annette. He may be a talented violinist...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“First chair,” he injected.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But he’s a jerk when it comes to opening his mouth.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But an endearing jerk,” he added.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I smiled. He did, indeed, seem endearing in addition to being rather adorable. His grin was impossible to resist. “I better get going. Roberta is probably already looking for me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hey, why don’t you meet up with us for lunch?” Chace asked. He shoved his hands into his jean pockets, and suddenly seemed nervous and shy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sure, that would be great.” I was already looking forward to spending more time with him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We’ll come back and meet you here at noon.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Cool, see you then.” I ran off. However, when I reached wardrobe Roberta informed me I wouldn’t be working on Marie’s dress as I’d planned.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You heard she skipped out?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yeah, kind of.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We can’t do nothing on this dress until they find a replacement and we get that girl’s measurements.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She found other tedious items to work on, but my mind was already on my lunch date with Judy and Chace. While he did come off slightly arrogant, there was something very appealing about him. By the time noon rolled around, I was jumping around on my seat, eager to get out, get fed, and get some air.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We ended up grabbing a hot-dog on Amsterdam and West 65"), _c('sup', [_vm._v("th")]), _vm._v(" and walked around the Lincoln Center. The air was cool and scented with autumn; though I had no idea what fall in New York would really smell like.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I can’t believe the show is actually being postponed,” Judy said through a mouthful. “I don’t think this has ever happened in the history of the Met.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ve certainly never seen a show with so many troubles. You’d almost think someone doesn’t want this particular show to go on,” Chace said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Judy and I both stopped and turned to him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What are you saying?” Judy asked, pointing the remaining half of her hot dog at him. “Someone is deliberately sabotaging the show?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Who knows?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But that growling,” I said, still feeling the shiver that sound had induced. “I heard it. I was there. No one was able to find where it came from. I think that Legend has something to do with this.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Or maybe someone just wanted to get rid of Marie.” Judy wiped mustard off the corner of her mouth. “It’s understandable.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hmmm.” Chace rubbed his chin thoughtfully and scrutinized Judy with mock suspicion. “And where were you yesterday at three o’clock?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hell, honey. If I’d wanted to get rid of her I wouldn’t just have fooled around with her music and some silly growling.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And don’t forget a dress that almost suffocated her,” I threw in.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("We all laughed, but it was a nervous laugh that left us all looking down at the pavement for a moment. I couldn’t help but wonder what would happen next. Would the strange sounds continue?  Would things get worse?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The remainder of our lunch was eaten in silence and soon we were back at the doors of the Opera where Judy left with the intent to audition elsewhere. “You never know how long this postponement will drag on for,” she said as she walked away.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And I better get back to work,” I told Chace.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hey, I was thinking of catching a movie later; something to cheer us up.  Feel like coming?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sure. Could be fun.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I guarantee it.” He laughed at the cockiness of his words and showed me that shy grin of his.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I hurried inside and headed to my station.  Roberta hadn’t returned from her lunch break yet nor had any of the other seamstresses. Getting some work done without the roar of sewing machines and buzz of conversations would be a pleasant change of pace. I had only a little work left to tend to and hurried to it. But instead of finding the trousers I’d been working on, I found several music sheets lying about.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The black dots and lines scattered across the page captivated me. I held in my hand the music penned by a phantom maestro and the romantic in me was aflutter. I heard the melody before I even realized I’d begun to read the notes and was humming the haunting song.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I glanced around.  Still no sign of Roberta. With the excitement of a child, I ran to the staircase, took the steps two at a time and headed down below the orchestra pit where an old abandoned piano sat in the gloom of the corner.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My fingers easily found the appropriate keys and the melody that emerged made me want to weep. Overcome with emotion, I struggled a moment to find my voice. When it finally came, it was heavy with longing and inexplicable sadness. The melody grew and heightened and my voice opened up, allowing all the pain of the lyrics to spill out; the heartache of loving one so deeply, only to learn of the coldness of his heart. A chill enveloped me and I shook it off.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Just as I was about to attempt the high C, just as the emotions of the song left my eyes tearing, I felt a shadow shift behind me.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26807838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c005.vue
// module id = 72
// module chunks = 0